<template>
  <div class="planInfo">
    <div class="mainCon">
      <el-table :data="tableData">
        <!-- <el-table-column style="width: 9%"></el-table-column> -->
        <el-table-column label="时段/星期" style="width: 9%">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.dayTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="周一" style="width: 9%;">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-switch
                v-model="scope.row.week['1']"
                :active-value="1"
                :inactive-value="-1"
                @change="changeSwitch($event,scope.row.week['1'])"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周二" style="width: 9%">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-switch
              v-model="scope.row.week['2']"
              :active-value="1"
              :inactive-value="-1"
              @change="changeSwitch($event,scope.row)"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周三" style="width: 9%">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.week['3']"
              :active-value="1"
              :inactive-value="-1"
              @change="changeSwitch($event,scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column label="周四" style="width: 9%">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.week['4']"
              :active-value="1"
              :inactive-value="-1"
              @change="changeSwitch($event,scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column label="周五" style="width: 9%">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.week['5']"
              :active-value="1"
              :inactive-value="-1"
              @change="changeSwitch($event,scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column label="周六" style="width: 9%">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.week['6']"
              :active-value="1"
              :inactive-value="-1"
              @change="changeSwitch($event,scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column label="周日" style="width: 9%">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.week['7']"
              :active-value="1"
              :inactive-value="-1"
              @change="changeSwitch($event,scope.row)"/>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" class="plan_btn" @click="getPlan">保存</el-button>
    </div>
  </div>
</template>

<script>
import { getServiceTimeList, setServiceTime } from "@/api";
export default {
  data() {
    return {
      jsonPlan:{},
      tableData: [
        {
          dayTime: "上午",
          dutyType: "值班",
          week: {},
        },
        {
          dayTime: "下午",
          dutyType: "值班",
          week: {},
        },
        {
          dayTime: "晚上",
          dutyType: "值班",
          week: {},
        },
      ],
      scope:''
    };
  },
  methods: {
    async getPlan(){
      try {
        const params = {
          // jsonPlan:this.scope.row.week
            morning:{
              week : this.tableData[0].week,
            },
            afternoon:{
              week : this.tableData[1].week,
            },
            night:{
              week : this.tableData[2].week,
            },
        };
        
      console.log(params);
        let res = await setServiceTime(params);
        console.log(res);
        if (res.success) {
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    },
    change:function(index,row){
      console.log(index,row);
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    async getDutyInfo() {
      try {
        const params = {};
        let res = await getServiceTimeList(params);
        console.log("getDutyInfo->res:",res);
        if (res.success) {
          let data = res.result;
          console.log("data:",data);
          this.tableData[0].week = data.morning.week
          this.tableData[1].week = data.afternoon.week
          this.tableData[2].week = data.night.week

        }
      } catch (error) {
        console.log(error);
      }
    },

    changeSwitch (val,row) {
    console.log(val,row);
    // if (val) {
    //   row.
    // }
    // const data = {
    //   id: row.id,
    //   status: row.status,
    // };
    // this.$api.accountSwitch(data).then(res => {
    //   if (res.code === '200' || res.code === 200) {
    //     // 调用表格数据
    //     this.getTableData();
    //   } else {
    //     this.$message.error(res.msg);
    //     // 调用表格数据
    //     this.getTableData();
    //   }
    //   this.loading = false;
    // }).catch({
      
    // });
  },
  },
 
  mounted() {
    this.getDutyInfo();
  },
};
</script>
<style lang="scss" scoped>
.name-wrapper{
  margin-left: -10px;
}
.planInfo {
  position: relative;
  width: 60%;
  margin: 20px;
  //   box-shadow: 0 2px 12p#ebeef5;
  // -webkit-box-shadow:0 2px 12px 0 #ebeef5;
  .mainCon {
    width: 100%;
    display:flex;
    flex-direction: row;
    padding:10px 0 50px 10px;
    border: 1px solid #ddd;
    box-shadow: 0 0 4px #ddd;
    .title {
      position: absolute;
      font-size: 20px;
      padding: 10px 0;
      margin-top: -30px;
    }
    .plan_btn{
      width: 70px;
      position: absolute;
      height: 30px;
      right: 10px;
      bottom: 10px;
      line-height: 30px;
      padding: 0;
    }
    table{
      width: 100%;
    }
  }
}
</style>